import { render } from "./overlay.html?vue&type=template&id=547142e2&scoped=true&external"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import "./overlay.vue?vue&type=style&index=0&id=547142e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547142e2"]])

export default __exports__